// extracted by mini-css-extract-plugin
export var active = "cases-module--active--7b84d";
export var bgImg = "cases-module--bg-img--c1883";
export var caseBg = "cases-module--case-bg--81db4";
export var caseBlock = "cases-module--case-block--d6c33";
export var caseHero = "cases-module--case-hero--96739";
export var caseHeroTable = "cases-module--case-hero-table--24a89";
export var caseImgWrap = "cases-module--case-img-wrap--0f59f";
export var caseItem = "cases-module--case-item--d0bdc";
export var caseLink = "cases-module--case-link--58621";
export var caseQuote = "cases-module--case-quote--03f06";
export var caseQuoteWrap = "cases-module--case-quote-wrap--7e116";
export var caseTags = "cases-module--case-tags--e9e6d";
export var caseTitle = "cases-module--case-title--54d5d";
export var casesNav = "cases-module--cases-nav--5fae2";
export var casesNavActive = "cases-module--cases-nav-active--b024c";
export var casesNavEllipsis = "cases-module--cases-nav-ellipsis--eaaae";
export var casesNavItem = "cases-module--cases-nav-item--4ab3c";
export var casesNavNext = "cases-module--cases-nav-next--2f52a";
export var casesNavOverview = "cases-module--cases-nav-overview--d2dfe";
export var casesNavPrev = "cases-module--cases-nav-prev--5603d";
export var casesOverview = "cases-module--cases-overview--88067";
export var casesPagination = "cases-module--cases-pagination--97218";
export var casesTagsList = "cases-module--cases-tags-list--9ed05";
export var quoteDots = "cases-module--quote-dots--07ccf";
export var tagActive = "cases-module--tag-active--32f72";